/** Object.keys() with types */
export function objectKeys(o) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Object.keys(o);
}